export const redemptionLimitsOptions = {
  single: {
    label: 'Single redemption',
    value: false,
  },
  multiple: {
    label: 'Multiple redemption',
    value: true,
  },
};

export const availDaysOptions = {
  everyDay: {
    label: 'Every Day',
    value: 'everyDay',
  },
  specificDays: {
    label: 'Every specific day of the week',
    value: 'specificDays',
  },
};
